export const getGcsUri = (args: { bucket: string; path: string }) => {
  return `gs://${args.bucket}/${args.path}`;
};
